import React, { createContext, useContext, useState } from 'react';

// 1. Créer le contexte
export const EvalNationalContext = createContext();

export const useEvalNationalContext = () => useContext(EvalNationalContext)

// 2. Créer un fournisseur de contexte
export const EvalNationalProvider = ({ children }) => {
  const [data, setData] = useState(null); // Remplacez par votre état initial et la logique

  return (
    <EvalNationalContext.Provider value={{ data, setData }}>
      {children}
    </EvalNationalContext.Provider>
  );
};